import { FieldType } from '../../../types/Field.type';
import { CurrencyRef } from '../../enm/Currency';
export const Currency = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.currency.label',
    fallbackLabel: 'Currency',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => isDisabled(payload, path),
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: FieldType.Enum,
    options: CurrencyRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    var _a, _b, _c, _d;
    return (((_b = (_a = payload.contract_onboarding_type) === null || _a === void 0 ? void 0 : _a.valueOf) === null || _b === void 0 ? void 0 : _b.call(_a)) === 'MANAGED_MERCHANT_IN_STORE' || ((_d = (_c = payload.contract_onboarding_type) === null || _c === void 0 ? void 0 : _c.valueOf) === null || _d === void 0 ? void 0 : _d.call(_c)) === 'KLARNA_POINT_OF_SALES');
}
function isDisabled(payload, path) {
    var _a, _b;
    return (((_b = (_a = payload.contract_onboarding_type) === null || _a === void 0 ? void 0 : _a.valueOf) === null || _b === void 0 ? void 0 : _b.call(_a)) === 'KLARNA_POINT_OF_SALES');
}
function isApplicable(payload, path) {
    var _a, _b;
    return (((_b = (_a = payload.contract_onboarding_type) === null || _a === void 0 ? void 0 : _a.valueOf) === null || _b === void 0 ? void 0 : _b.call(_a)) === 'MEDIA');
}
